import { handleActions } from 'redux-actions';
import reducersUtils from 'state/utils';

import actions from 'state/direct-order-recurring/insurance/actionCreators';

import initialState from 'state/direct-order-recurring/insurance/initial.state';

const insurance = handleActions(
  {
    [reducersUtils.RESET_ORDER_STATE]: () => initialState,
    [actions.setInsuranceQuantity]: (
      state,
      { payload: { insuranceQuantity } }
    ) => ({
      ...state,
      insured_for: isNaN(insuranceQuantity)
        ? undefined
        : Number(insuranceQuantity),
    }),
    [actions.cleanInsurance]: () => initialState,
  },
  initialState
);

export default insurance;
